// extracted by mini-css-extract-plugin
export default {"modalWrapper":"styles_modalWrapper__32ZTs","modalContent":"styles_modalContent__DhD6T","text":"styles_text__KK75S","subText":"styles_subText__sMMCY","button":"styles_button__LWxXX"};